// removed by extract-text-webpack-plugin
module.exports = {"container":"_3-dhv6J2dWGBzZt6v8a9Au","searchField":"_1vCfW6PXLDssXCxWUwx8J8"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Exchange/Layout/Navbar/Markets/Menu/FilterBar/Desktop/SearchBar/styles.css
// module id = 1583
// module chunks = 85